import * as preact from "preact";

import { shareLink, sharesBySheet } from "shareLink";
import stores from "stores/stores";

interface Props {}

interface State {}

class ShareBookView extends preact.Component<Props, State> {
  render() {
    const linkUrl = `https://readlang.com/library/${stores.bookModel.id}`;

    return (
      <div>
        <p>
          If you're enjoying this text, help out a fellow learner by sharing it!
        </p>

        {stores.bookModel.isUserTheOwner() ? (
          <div>
            <p>
              <label>
                <input
                  type="checkbox"
                  checked={stores.bookModel.book.value.public}
                  onChange={async (event) => {
                    await stores.bookModel.patchBook({
                      public: event.currentTarget.checked,
                    });
                    this.forceUpdate();
                  }}
                />{" "}
                Make this text public
              </label>{" "}
              <small>
                (only do this if you have permission from the copyright holder)
              </small>
            </p>
          </div>
        ) : null}

        {stores.bookModel.book.value.public ? (
          <div>
            <p>
              Permanent link:{" "}
              <a style={{ fontSize: "80%" }} href={linkUrl}>
                {linkUrl}
              </a>
            </p>
            <p>
              <button
                onClick={() =>
                  shareLink({
                    title: stores.bookModel.book.value.title ?? "",
                    url: linkUrl,
                  })
                }
              >
                {sharesBySheet() ? "Share…" : "Copy link to clipboard"}
              </button>
            </p>
          </div>
        ) : null}
      </div>
    );
  }
}

export default ShareBookView;
